// src/stores/useCoverageFlyoutStore.js
//
// Tiny shared-UI store: is the per-series county coverage flyout open?
//
// Exists solely so the map-surface change-detection controls
// (FlickerModeButton, Explore's time strip; CompareModeButton until S-e slice 4b) can render-gate
// themselves without prop-drilling across the LayerPanel ↔ MapView
// boundary. The flyout's "which series is open" stays local to
// ImageryTab; this store carries just the derived boolean.
//
// Crucially: comparison/flicker/cursor STATE lives in
// useImageryStackStore and is unaffected by this flag. Toggling isOpen
// only hides/shows the *control UI* — the comparison instance, the
// flicker timer, and the cursor position all persist across open/close.

import { create } from "zustand";

export const useCoverageFlyoutStore = create((set) => ({
  isOpen: false,
  setOpen: (isOpen) => set({ isOpen: !!isOpen }),
}));
